module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-Medium-0e121b4fa4d6e9bc5c69eabb74d853dc.ttf";